import { render, staticRenderFns } from "./AudabridgeSubmitImagesModal.vue?vue&type=template&id=54341fa2&scoped=true"
import script from "./AudabridgeSubmitImagesModal.vue?vue&type=script&lang=js"
export * from "./AudabridgeSubmitImagesModal.vue?vue&type=script&lang=js"
import style0 from "./AudabridgeSubmitImagesModal.vue?vue&type=style&index=0&id=54341fa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54341fa2",
  null
  
)

export default component.exports